<div class="section">
  <div class="table-wrapper">
    <div class="table-container table-light">
      <table>
        <colgroup>
          <col class="col-index" />
          <col class="col-name" />
          <col class="col-code" />
          <col class="col-type" />
          <col class="col-price" />
          <col class="col-price" />
          <col class="col-date" />
          <col class="col-date" />
          <col class="col-invoice" />
          <col class="col-cycle" />
          <col class="col-action" />
        </colgroup>
        <thead>
          <tr>
            <th class="col-index">#</th>
            <th class="col-name">Name</th>
            <th class="col-code">Product Code</th>
            <th class="col-type">Type</th>
            <th class="col-price">Price Paid</th>
            <th class="col-price">Vat</th>
            <th class="col-date">Date Purchased</th>
            <th class="col-date">Renewal Date</th>
            <th class="col-invoice">Invoice</th>
            <th class="col-cycle">Cycle</th>
            <th class="col-action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of subscriptions; let i = index">
            <td class="col-index">{{ i + 1 }}</td>
            <td class="course-name col-name">{{ item.name }}</td>
            <td class="col-code">{{ item.product_code }}</td>
            <td class="col-type">{{ item.type }}</td>
            <td class="price col-price">{{ item.price }}</td>
            <td class="price col-price">{{ item.vat }}</td>
            <td class="col-date">{{ item.subscription_day }}</td>
            <td class="col-date">{{ item.renewal_date }}</td>
            <td class="col-invoice"><a class="btn-download" href="#" (click)="downloadInvoice(item); $event.preventDefault()">Download</a></td>
            <td class="col-cycle"><span class="cycle-badge">{{ item.cycle }}</span></td>
            <td class="col-action">
              <div class="action-buttons">
                <ng-container *ngIf="item.can_renew">
                  <button class="btn-buy" (click)="renewSubscription(item)">Renew</button>
                </ng-container>
                <ng-container *ngIf="!item.can_renew">
                  <button class=" btn-renew" (click)="buyApp(item)">{{ item.btn_message }}</button>
                </ng-container>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
